import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Єдина функція ініціалізації
function initAboutHeroParallax(root = document) {
    const section = root.querySelector("[data-about-hero]");
    if (!section) return;
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const bg = section.querySelector(".aboutHeroSection__bg");
    if (!bg) return;

    const AMP_DESKTOP = 0.35;   // було 0.25 → стане помітніше
    const AMP_MOBILE  = 0.22;   // на мобі делікатніше
    const BIAS_PX     = 24;     // старт трохи нижче, щоб верх не обрізало

    const mq = window.matchMedia("(max-width: 768px)");
    const rangePx = () => Math.round(window.innerHeight * (mq.matches ? AMP_MOBILE : AMP_DESKTOP));

    gsap.fromTo(bg,
        { backgroundPosition: () => `50% ${BIAS_PX}px` },
        {
            backgroundPosition: () => `50% ${BIAS_PX + rangePx()}px`,
            ease: "none",
            willChange: "background-position",
            scrollTrigger: { trigger: section, start: "top top", end: "bottom top", scrub: true, invalidateOnRefresh: true }
        }
    );

    const btn = section.querySelector(".aboutHeroSection__scroll");
    if (btn) {
        btn.addEventListener("click", () => {
            const next = section.nextElementSibling;
            if (next) next.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    }
}

// автостарт
if (document.readyState !== "loading") initAboutHeroParallax();
else document.addEventListener("DOMContentLoaded", () => initAboutHeroParallax());

export { initAboutHeroParallax };



function initHeroScroll(root=document){
        root.querySelectorAll('.aboutHeroSection__scroll').forEach(btn=>{
            const section = btn.closest('.aboutHeroSection');
            if(!section) return;
            let next = section.nextElementSibling;
            // пропустити технічні порожні елементи
            while (next && next.tagName === 'SCRIPT') next = next.nextElementSibling;

            if(!next){ btn.hidden = true; return; }

            const go = () => next.scrollIntoView({ behavior: 'smooth', block: 'start' });
            btn.addEventListener('click', go);
            btn.addEventListener('keydown', (e)=>{
                if(e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
            });
        });
    }

(function runAboutHero() {
    const start = () => {
        const wrap = document.querySelector('.aboutHeroSection__wrapper');
        const els = [
            '.aboutHeroSection__subtext',
            '.aboutHeroSection__title',
            '.aboutHeroSection__text'
        ].map(sel => wrap.querySelector(sel)).filter(Boolean);

        // миттєвий старт у найближчий кадр рендеру
        requestAnimationFrame(() => {
            gsap.to(els, {
                autoAlpha: 1,
                y: 0,
                duration: 0.6,
                ease: 'power2.out',
                stagger: 0.06,
                lazy: false,
                overwrite: 'auto',
                force3D: true
            });
        });
    };

    if (document.readyState !== 'loading') start();
    else document.addEventListener('DOMContentLoaded', start);
})();
    function initAboutVideoSection(root = document){
        const wrap = root.querySelector('[data-about-video]');
        if (!wrap) return;

        const video = wrap.querySelector('.aboutVideoSection__tag');
        const btn   = wrap.querySelector('.aboutVideoSection__play');
        const ui    = wrap.querySelector('.aboutVideoSection__controls');
        const vol   = ui.querySelector('.avc__vol');
        const mute  = ui.querySelector('.avc__mute');
        const seek  = ui.querySelector('.avc__seek');
        const curT  = ui.querySelector('.avc__cur');
        const durT  = ui.querySelector('.avc__dur');

        // ===== джерела + постер =====
        const mp4    = wrap.dataset.mp4   || '';
        const webm   = wrap.dataset.webm  || '';
        const poster = wrap.dataset.poster|| '';
        if (poster) video.setAttribute('poster', poster);

        // додати sources (без жодного seek!)
        video.querySelectorAll('source').forEach(n=>n.remove());
        if (webm){ const s=document.createElement('source'); s.src=webm; s.type='video/webm'; video.appendChild(s); }
        if (mp4){  const s=document.createElement('source'); s.src=mp4;  s.type='video/mp4';  video.appendChild(s); }

        // тримаємо постер до кліку: лише metadata, без автобаферингу кадрів
        video.preload = 'metadata';
        video.load();

        // ===== helpers =====
        const fmt = secs => {
            secs = Math.max(0, Math.floor(secs || 0));
            const m = String(Math.floor(secs/60)).padStart(2,'0');
            const s = String(secs%60).padStart(2,'0');
            return `${m}:${s}`;
        };
        function setRangeBG(el, ratio){
            const fill = '#D1D5DB', rest = 'rgba(255,255,255,.25)';
            const pct  = Math.max(0, Math.min(100, ratio*100));
            el.style.background = `linear-gradient(90deg, ${fill} ${pct}%, ${rest} ${pct}%)`;
        }
        const updateVolBG  = ()=> setRangeBG(vol,  parseFloat(vol.value || '0'));
        const updateSeekBG = ()=> setRangeBG(seek, (parseInt(seek.value,10) || 0) / 1000);
        function setSeek(val){
            const v = String(val);
            seek.min='0'; seek.max='1000'; seek.step='1';
            seek.value=v; seek.setAttribute('value', v);
            updateSeekBG();
        }
        const showUI = ()=>{
            if (!ui.hidden){ updateVolBG(); updateSeekBG(); return; }
            ui.hidden = false; updateVolBG(); updateSeekBG();
        };

        // стартові налаштування звуку: показуємо 100% і гратимемо зі звуком після кліку
        vol.value    = '1';
        video.volume = 1;
        video.muted  = false; // важливо для старту зі звуком після користувацької дії

        // показати панель, коли зчитали метадані (постер при цьому не зникає)
        video.addEventListener('loadedmetadata', ()=>{
            durT.textContent = fmt(video.duration);
            setSeek(0);
            curT.textContent = '00:00';
            showUI();
        }, { once:true });

        // ===== Play (зі звуком, без попереднього seek) =====
        btn.addEventListener('click', async ()=>{
            try{
                // на всяк випадок: прибрати можливий muted-атрибут
                if (video.hasAttribute('muted')) video.removeAttribute('muted');
                video.muted  = false;
                video.volume = parseFloat(vol.value || '1') || 1;

                if (video.currentTime !== 0){ try{ video.currentTime = 0; }catch(e){} }
                setSeek(0);

                await video.play();
                btn.hidden = true;
                // як тільки відео починає грати, браузер автоматично прибирає постер і показує відео
            }catch(e){ console.warn('Play error', e); }
        }, { passive:true });

        // клік по секції — пауза/продовження
        wrap.addEventListener('click', async (e)=>{
            const isControl = e.target.closest('.aboutVideoSection__controls') || e.target.closest('.aboutVideoSection__play');
            if (isControl) return;

            if (video.paused){
                btn.hidden = true;
                try{
                    if (video.hasAttribute('muted')) video.removeAttribute('muted');
                    video.muted  = false;
                    video.volume = parseFloat(vol.value || '1') || 1;
                    await video.play();
                }catch(e){}
            } else {
                video.pause();
                btn.hidden = false;
            }
        });

        // таймлайн
        video.addEventListener('timeupdate', ()=>{
            const t = Math.max(0, video.currentTime || 0);
            curT.textContent = fmt(t);
            if (Number.isFinite(video.duration) && video.duration > 0){
                const val = Math.round((t / video.duration) * 1000);
                if (seek.value !== String(val)){
                    seek.value = String(val);
                    updateSeekBG();
                }
            }
        });

        // seek
        seek.addEventListener('input', ()=>{
            if (!Number.isFinite(video.duration)) return;
            const t = (parseInt(seek.value,10) / 1000) * video.duration;
            video.currentTime = t;
            updateSeekBG();
        });

        // volume / mute
        vol.addEventListener('input', ()=>{
            video.volume = parseFloat(vol.value);
            video.muted  = (video.volume === 0);
            updateVolBG();
        });
        mute.addEventListener('click', ()=>{
            video.muted = !video.muted;
            if (!video.muted && video.volume === 0){ vol.value = '1'; video.volume = 1; }
            updateVolBG();
        });
    }
    // about-anim.js (ESM)


    // ==== About page reveals (hero — одразу; інше — лише при доскролі) ====

    function animateAboutHero(root) {
        const hero = root.querySelector('.aboutHeroSection__wrapper');
        if (!hero) return;

        const heroEls = [
            '.aboutHeroSection__subtext',
            '.aboutHeroSection__title',
            '.aboutHeroSection__text'
        ].map(sel => hero.querySelector(sel)).filter(Boolean);

        // Початкові стани краще задати в CSS (див. нижче), тоді сет не потрібен
        // gsap.set(heroEls, { autoAlpha: 0, y: 28 });

        // Старт миттєво: без delay, без lazy
        requestAnimationFrame(() => {
            gsap.to(heroEls, {
                autoAlpha: 1,
                y: 0,
                duration: 0.6,
                ease: 'power2.out',
                stagger: 0.06,
                lazy: false,          // ← головне для моментального старту
                overwrite: 'auto',
                force3D: true
            });
        });
    }

    // Гарантовано після DOM, не чекаємо window.onload
    if (document.readyState !== 'loading') {
        animateAboutHero(document);
    } else {
        document.addEventListener('DOMContentLoaded', () => animateAboutHero(document));
    }

    function initAboutRevealAnimations(root = document) {
        gsap.registerPlugin(ScrollTrigger);

        // повага до prefers-reduced-motion (як і на careers)
        const ignorePRM = document.documentElement.getAttribute('data-ignore-prm') === '1';
        const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce && !ignorePRM) return;



        // 2) Решта — тільки при доскролі (НЕ чіпаємо картинки/відео)
        const selectors = [
            // values
            '.aboutValuesSection__title',
            '.aboutValuesSection__item',
            // text+image (ліва колонка — тільки текст)
            '.aboutTextImageSection__subtext',
            '.aboutTextImageSection__title',
            '.aboutTextImageSection__text',
            // extra text+image
            '.aboutTextImageExtraSection__subtext',
            '.aboutTextImageExtraSection__title',
            '.aboutTextImageExtraSection__text',
            // CTA
            '.basicCTASection__title',
            '.basicCTASection__text',
            '.basicCTASection .btn'
        ];

        const targets = gsap.utils.toArray(selectors.join(',')).filter(el => root.contains(el));

        // стартовий стан
        gsap.set(targets, { autoAlpha: 0, y: 28 });

        targets.forEach((el, i) => {
            // створюємо твін (не програємо одразу)
            const tween = gsap.fromTo(
                el,
                { autoAlpha: 0, y: 28 },
                {
                    autoAlpha: 1,
                    y: 0,
                    duration: 0.6,
                    ease: 'power2.out',
                    immediateRender: false
                }
            );

            ScrollTrigger.create({
                trigger: el,
                start: 'top 82%',
                toggleActions: 'play none none none',
                once: true,
                invalidateOnRefresh: true,
                animation: tween,
                // легка «драбинка» для плиток values
                onEnter: () => {
                    if (el.matches('.aboutValuesSection__item')) {
                        tween.delay((i % 4) * 0.05);
                    }
                }
                // markers: true,
            });
        });

        // після повного завантаження (картинки/відео) — перерахувати тригери
        window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
    }

    // твій виклик — як ти й хочеш
    document.addEventListener('DOMContentLoaded', () => initAboutRevealAnimations(document));








    if (document.readyState !== 'loading') initHeroScroll();
    else document.addEventListener('DOMContentLoaded', () => initHeroScroll());

    document.addEventListener('DOMContentLoaded', ()=>{
        initAboutVideoSection(document);
    });